import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Sum of the `percentage` controls of a beneficiaries FormArray. */
export function beneficiaryPercentageTotal(array: AbstractControl | null | undefined): number {
  if (!(array instanceof FormArray)) return 0;
  const total = array.controls.reduce((sum, group) => {
    const raw = group.get('percentage')?.value;
    const value = raw === '' || raw == null ? 0 : Number(raw);
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);
  return Math.round(total * 100) / 100;
}

/** FormArray validator: when there are rows, their percentages must add up to 100. */
export function beneficiaryPercentageSumValidator(tolerance = 0.01): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray) || control.length === 0) return null;
    const total = beneficiaryPercentageTotal(control);
    return Math.abs(total - 100) > tolerance ? { percentageSum: { total } } : null;
  };
}

/** FormArray validator: at least `min` rows. */
export function minBeneficiariesValidator(min = 1): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    control instanceof FormArray && control.length < min ? { minBeneficiaries: { min } } : null;
}
